import { getActiveAgent } from "./getActiveAgent";

export const getServicingAgents = (policy) => {
  const serviceAgents = policy?.agents?.filter(
    (agent) => agent.agentType === "Servicing Agent"
  );
  // Return only Active Servicing Agent
  return getActiveAgent(serviceAgents, policy);
};
